import { Component, OnInit, Input } from '@angular/core';
import { NotificationsService } from '../../shared/services/notifications.service';
import { DateTime } from 'luxon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification-history',
  templateUrl: './notification-history.component.html',
  styleUrls: ['./notification-history.component.scss']
})
export class NotificationHistoryComponent implements OnInit {

  @Input() notificationId: number;
  notificationHistory: any;

  displayedColumns: string[] = ['notificationHistoryTypeName', 'byUser', 'dateOccured', 'fromUser', 'toUser'];

  constructor(
    private notificationsService: NotificationsService,
    public activeModal: NgbActiveModal) {
   }

    ngOnInit(): void {
      this.loadHistory();
    }

    loadHistory(){

      this.notificationsService.notificationHistory(this.notificationId).subscribe(result => {

        this.notificationHistory = result.notificationHistory;

      }, error => {

        var errorMessage = "Failed to get notification history";
        if (error.error !== null && error.error.message !== undefined) {
          errorMessage = error.error.message;
        }

      });
    }

    formatDateWithTime(inDate : any){

      var formattedDate = '';

       if(inDate !== null)
       {
         var dt = DateTime.fromISO(inDate);
         formattedDate = dt.toFormat("dd-MM-yyyy HH:mm:ss");
          if(formattedDate == 'Invalid date')
         formattedDate = '';
       }
       return formattedDate;
   }


}
